/* SP-I18N-EN (09.10.2026) – Englische Texte für /en/
   Geladen nur auf /en/ (sections/sp-ss-header-minimal.liquid, ganz oben im Body).
   Übersetzt deutsche Texte, die fest im Theme stehen oder per JS gebaut werden (Produktseite, Logo-Vorschau,
   Musterbox, Cross-Selling, Warenkorb-Hinweise, Footer-Reste). Inhalte aus dem Admin (Produkte, Seiten,
   Section-Einstellungen) bitte weiter über „Translate & Adapt“ übersetzen – das hier ist das Netz darunter.
   Neue deutsche Texte: unten in X (ganzer Text), POS (Druckpositionen) oder R (Muster mit Zahlen) ergänzen. */
(function () {
  if (!/^en/i.test(document.documentElement.lang || '')) return;
  // SP-I18N-EN (10.10.2026): Überschrift „Logo-Datei“ über dem Upload kommt per CSS (content) aus sp-pdp-neu-ci.css
  (function () { var st = document.createElement('style'); st.textContent = 'html .spn .spn-logo .spn-lrow--split::before{content:"Logo file"}'; (document.head || document.documentElement).appendChild(st); })();

  var X = {
    // Produktseite – Kopf, Ablauf, Material
    'Brotkrumen': 'Breadcrumb',
    'Preis': 'Price',
    'So läuft deine Bestellung': 'How your order works',
    'Bestellen': 'Order',
    'Farben, Größen und Veredelung wählen, Logo hochladen oder später senden.': 'Choose colours, sizes and finishing, upload your logo or send it later.',
    'Druckfreigabe': 'Print approval',
    'Du bekommst eine digitale Vorschau. Produziert wird erst nach deinem OK.': 'You get a digital preview. Production only starts after your OK.',
    'Produktion': 'Production',
    'Druck & Stick im eigenen Haus in München.': 'Printing & embroidery in-house in Munich.',
    'Versand': 'Shipping',
    'Direkt zu dir oder deinem Team.': 'Straight to you or your team.',
    'Material & Pflege': 'Material & care',
    'Grammatur': 'Fabric weight',
    'Waschen': 'Washing',
    'Bügeln': 'Ironing',
    'Pflege im Detail': 'Care in detail',
    'Die genauen Materialangaben zu diesem Artikel nennen wir dir gerne auf Anfrage.': 'We are happy to give you the exact material details for this item on request.',
    'Damit dein bedrucktes Teil lange schön bleibt: wasche es schonend und am besten auf links, das schützt Druck und Stoff gleichermaßen. Nach dem Waschen kurz ausschütteln, damit es wieder in Form kommt. Schwarze und dunkle Textilien wäschst du am besten getrennt, idealerweise mit einem Schwarz- oder Colorwaschmittel. Gebügelt wird nie direkt über das Motiv, sondern von links oder mit einem Tuch dazwischen. Und falls es mal richtig heiß hergeht: ein stark verschwitztes Teil vor dem Waschen kurz einweichen – dann bleibt alles frisch.': 'To keep your printed garment looking good for a long time, wash it gently and preferably inside out – this protects both the print and the fabric. Give it a quick shake after washing so it gets back into shape. Black and dark textiles are best washed separately, ideally with a detergent for blacks or colours. Never iron directly over the design – iron from the inside or with a cloth in between. And if things get really hot: soak a very sweaty garment briefly before washing – then everything stays fresh.',
    'Lieferzeit ca. 7–10 Werktage': 'Delivery time approx. 7–10 working days',
    'Textil ohne Veredelung · je Stück': 'Textile without finishing · per piece',
    'Textil ohne Veredelung': 'Textile without finishing',
    'Veredelung je Stück': 'Finishing per piece',
    'Digitaldruck': 'Digital print',
    'Stick': 'Embroidery',
    'Inkl. MwSt., zzgl. Versand': 'Incl. VAT, plus shipping',
    'inkl. MwSt., zzgl. Versand': 'incl. VAT, plus shipping',
    'ab': 'from',
    'Ab': 'From',
    // Schritt 1–2
    'Farben wählen': 'Choose colours',
    'Farben': 'Colours',
    'Im Bild:': 'In the photo:',
    'Größen & Mengen': 'Sizes & quantities',
    'Größenmix auf alle Farben': 'Apply size mix to all colours',
    'Wähle oben mindestens eine Farbe – dann erscheint hier die Größenzeile.': 'Choose at least one colour above – the size row will then appear here.',
    'Nicht verfügbar': 'Not available',
    'Nicht lieferbar': 'Not available',
    'Durchgestrichen = derzeit nicht lieferbar': 'Crossed out = currently unavailable',
    'Zahl unter dem Feld = sofort lieferbar': 'Number below the field = available now',
    '– = nicht lieferbar': '– = not available',
    'Mindestmenge erreicht – Farben und Größen frei kombinierbar.': 'Minimum quantity reached – mix colours and sizes freely.',
    // Schritt 3
    'Logos & Veredelung': 'Logos & finishing',
    '1 Logo': '1 logo',
    'Vorne': 'Front',
    'Hinten': 'Back',
    'Ärmel': 'Sleeve',
    'Kragen': 'Collar',
    'Ansicht': 'View',
    'Technik': 'Technique',
    'Position': 'Position',
    'Breite': 'Width',
    'Volle Farbigkeit, Verläufe': 'Full colour, gradients',
    'Bis 3 Garnfarben, edel': 'Up to 3 thread colours, premium',
    'Nur im Digitaldruck möglich': 'Only possible as digital print',
    'Nur als Stick möglich': 'Only possible as embroidery',
    'Nicht möglich': 'Not possible',
    'Schon durch das andere Logo belegt': 'Already taken by the other logo',
    'Höhe proportional': 'Height proportional',
    'Logo-Datei wählen': 'Choose logo file',
    'PDF, SVG, AI oder PNG': 'PDF, SVG, AI or PNG',
    'Zweites Logo hinzufügen': 'Add a second logo',
    'z. B. Rücken, Schulterblatt oder die andere Brustseite': 'e.g. back, shoulder blade or the other side of the chest',
    'Logo-Dateien schicke ich nach der Bestellung per E-Mail': 'I’ll send the logo files by email after ordering',
    'Kein Problem: Nach der Bestellung schickst du uns dein Logo per E-Mail. Kein Vektor? Wir prüfen dein Logo und bereiten es mit dir auf – kostenlose Layout-Beratung inklusive.': 'No problem: send us your logo by email after ordering. No vector file? We’ll check your logo and prepare it with you – free layout advice included.',
    'Die genaue Platzierung zeigen wir dir mit der Druckfreigabe, bevor wir produzieren.': 'We’ll show you the exact placement with the print approval before we produce.',
    'Die Datei ist größer als 20 MB. Schick sie uns gern nach der Bestellung per E-Mail.': 'The file is larger than 20 MB. Feel free to send it to us by email after ordering.',
    'Druckfreigabe per E-Mail': 'Print approval by email',
    'Die Vorschau auf dem Foto ist eine erste Ansicht deines Logos. Vor der Produktion schicken wir dir eine digitale Vorschau mit genauer Größe und Position zur Freigabe. Erst nach deinem OK legen wir los.': 'The preview on the photo is a first look at your logo. Before production we send you a digital preview with the exact size and position for your approval. We only start once you give your OK.',
    // Logo-Vorschau
    'In deinen Farben ansehen': 'See it in your colours',
    'Vorschau in deinen Farben': 'Preview in your colours',
    'Position zurücksetzen': 'Reset position',
    'Logo ziehen zum Verschieben.': 'Drag the logo to move it.',
    'Hinten ist noch kein Logo platziert.': 'No logo placed on the back yet.',
    'Vorne ist noch kein Logo platziert.': 'No logo placed on the front yet.',
    'Vorschau ungefähr – die genaue Platzierung zeigen wir dir mit der Druckfreigabe.': 'Approximate preview – we’ll show you the exact placement with the print approval.',
    'Für diese Farbe gibt es kein Foto der Rückseite – die Vorschau nutzt das Vorderfoto.': 'There is no back photo for this colour – the preview uses the front photo.',
    // Schritt 4 / Zusammenfassung
    'Deine Bestellung': 'Your order',
    'Trag in Schritt 2 deine Mengen ein, dann siehst du hier deinen Preis.': 'Enter your quantities in step 2 to see your price here.',
    'Staffelrabatt': 'Volume discount',
    'Gesamt inkl. MwSt.': 'Total incl. VAT',
    'In den Warenkorb': 'Add to cart',
    'kostenfrei': 'free',
    'Versand kostenfrei.': 'Free shipping.',
    'Danach versandkostenfrei.': 'Then free shipping.',
    'Mindestbestellwert erreicht': 'Minimum order value reached',
    'Höchste Staffel erreicht': 'Highest discount tier reached',
    'Mindestwert erreicht': 'Minimum reached',
    'Druckfreigabe vor Produktion': 'Print approval before production',
    'Druck & Stick im eigenen Haus': 'Printing & embroidery in-house',
    'Kauf auf Rechnung': 'Pay by invoice',
    'Der Staffelrabatt wird im Warenkorb automatisch abgezogen.': 'The volume discount is deducted automatically in the cart.',
    'Wird in den Warenkorb gelegt …': 'Adding to cart …',
    'Fehler beim Hinzufügen': 'Error adding to cart',
    'Zum Warenkorb': 'Go to cart',
    'Das hat nicht geklappt. Bitte versuche es erneut.': 'That didn’t work. Please try again.',
    // Musterbox
    'Erst ein Muster bestellen': 'Order a sample first',
    'Fühl Stoff, Farbe und Passform, bevor du bestellst. Wir schicken dir den Artikel unveredelt in deiner Farbe und Größe.': 'Feel the fabric, colour and fit before you order. We’ll send you the item without finishing in your colour and size.',
    'Farbe ·': 'Colour ·',
    'Größe ·': 'Size ·',
    'bitte wählen': 'please choose',
    'Weniger Farben': 'Fewer colours',
    'Nur für Geschäftskunden': 'Business customers only',
    'Muster sind von Rückgabe und Umtausch ausgeschlossen.': 'Samples cannot be returned or exchanged.',
    'Musterpreis': 'Sample price',
    'doppelter Artikelpreis': 'twice the item price',
    'In die Musterbox': 'Add to sample box',
    'Muster per E-Mail anfragen': 'Request a sample by email',
    'Deine Musterbox:': 'Your sample box:',
    'Deine Musterbox ·': 'Your sample box ·',
    'Deine Musterbox': 'Your sample box',
    'Zur Musterbox →': 'Go to sample box →',
    'In der Musterbox': 'In the sample box',
    'Weitere Farbe oder Größe als Muster': 'Another colour or size as a sample',
    'Wähle eine Größe.': 'Choose a size.',
    'Diese Größe ist gerade nicht lieferbar.': 'This size is currently unavailable.',
    'Dieses Teil ist schon in deiner Musterbox.': 'This item is already in your sample box.',
    'Für Muster gilt kein Mindestbestellwert.': 'No minimum order value applies to samples.',
    // Cross-Selling
    'Perfekt kombinierbar': 'Goes perfectly with',
    'Ergänze dein Branding mit passenden Produkten für Teams, Events & Firmenkleidung.': 'Complete your branding with matching products for teams, events & corporate wear.',
    'Zurück': 'Previous',
    'Weiter': 'Next',
    // Warenkorb, Footer, Sonstiges
    'Alle löschen': 'Remove all',
    'Gehört zu': 'Belongs to',
    'Fußzeilen-Navigation': 'Footer navigation',
    'Vertrag widerrufen': 'Withdraw from contract',
    'VERTRAG WIDERRUFEN': 'WITHDRAW FROM CONTRACT',
    'Kostenlos & unverbindlich': 'Free & without obligation',
    'Folge uns': 'Follow us',
    'Hinweis schließen': 'Close notice',
    'Chat über WhatsApp starten': 'Start a WhatsApp chat',
    'Projekt anfragen – Kostenlos und unverbindlich': 'Request a project – free and without obligation',
    '. Schauen Sie sich gerne noch etwas um!': '. Feel free to keep browsing!',
    'Um Ihre Bestellung abzuschließen, benötigen wir einen Mindestbestellwert von': 'To complete your order, we need a minimum order value of'
  };

  // Druckpositionen (aus den Aris-Optionen und der Logo-Vorschau)
  var POS = {
    'Brust links': 'Left chest', 'Brust rechts': 'Right chest', 'Brust Mitte': 'Centre chest', 'Brust mittig': 'Centre chest',
    'Nacken': 'Neck', 'Schulterblatt': 'Shoulder blade', 'Rücken komplett': 'Full back', 'Rücken': 'Back',
    'Ärmel links': 'Left sleeve', 'Ärmel rechts': 'Right sleeve',
    'Kragen links': 'Left collar', 'Kragen rechts': 'Right collar',
    'Vorne Mitte': 'Front centre', 'Vorne mittig': 'Front centre', 'Hinten Mitte': 'Back centre',
    'Seite links': 'Left side', 'Seite rechts': 'Right side', 'Bein links': 'Left leg', 'Bein rechts': 'Right leg',
    // SP-I18N-POS2 (11.10.2026): Positionen aus den Aris-Sätzen für Taschen, Rucksäcke, Schürzen, Mützen, Schirme, Sweatshirts
    'Brust komplett': 'Full chest', 'Vorne links': 'Front left', 'Vorne rechts': 'Front right', 'Vorne klein links': 'Front small left',
    'Vorne großflächig': 'Front large', 'Vorne groß mittig': 'Front large centre', 'Rückseite mittig': 'Back centre', 'Fronttasche': 'Front pocket',
    'Querstreifen oben': 'Strip at the top', 'Klein oben mittig': 'Small top centre', 'Latz mittig': 'Bib centre', 'Latz links': 'Bib left',
    'Latz groß': 'Bib large', 'Bauch links': 'Waist left', 'Bauch rechts': 'Waist right', 'Mütze': 'Beanie',
    'Krempe vorne': 'Front cuff', // SP-MUETZE (12.10.2026)
    '1-Segment bedrucken': 'Print 1 panel', '2-Segmente bedrucken': 'Print 2 panels', '4-Segmente bedrucken': 'Print 4 panels'
  };
  function pos(s) { return POS[s] || s; }
  function pcs(n) { return n + (n === '1' ? ' piece' : ' pieces'); }

  // Ganze Texte mit Zahlen (verankert)
  var R = [
    [/^ab (.+?) je Stück$/, function (m, a) { return 'from ' + a + ' per piece'; }],
    [/^(A|a)b (.+?) \/ Stk\.?$/i, function (m, a, b) { return (a === 'A' ? 'From ' : 'from ') + b + ' / pc'; }],
    [/^ab (€?\s?\d.*)$/, 'from $1'],
    [/^Ab (€?\s?\d.*)$/, 'From $1'],
    [/^(.+?) \/ Stk\.$/, '$1 / pc'],
    [/^\/ Stk\.$/, '/ pc'],
    [/^(\d+) Stk\.$/, '$1 pcs'],
    [/^(\d+) Stk\. inkl\. Veredelung$/, '$1 pcs incl. finishing'],
    [/^(\d+) Farben$/, '$1 colours'],
    [/^1 Farbe$/, '1 colour'],
    [/^\+ (\d+) Farben$/, '+ $1 colours'],
    [/^von (\d+) gewählt$/, 'of $1 selected'],
    [/^Bild (\d+) anzeigen$/, 'Show image $1'],
    [/^Alle Artikel von (.+)$/, 'All items from $1'],
    [/^bis zu (\d+) Logos$/, 'up to $1 logos'],
    [/^Logo (\d+) entfernen$/, 'Remove logo $1'],
    [/^(.+) entfernen$/, 'Remove $1'],
    [/^Technik Logo (\d+)$/, 'Technique logo $1'],
    [/^Logobreite Logo (\d+) in cm$/, 'Logo width, logo $1, in cm'],
    [/^Menge (.+), nicht lieferbar$/, 'Quantity $1, not available'],
    [/^Menge (.+), (\d+) lieferbar$/, 'Quantity $1, $2 available'],
    [/^Menge (.+)$/, 'Quantity $1'],
    [/^(.+) – derzeit nicht lieferbar$/, '$1 – currently unavailable'],
    [/^(.+), derzeit nicht lieferbar$/, '$1, currently unavailable'],
    [/^(.+): nur (\d+) Stück sofort lieferbar\. Wir haben deine (\d+) auf (\d+) gesetzt\.$/, '$1: only $2 pieces available now. We have changed your $3 to $4.'],
    [/^Nur (\d+) Stück sofort lieferbar$/, 'Only $1 pieces available now'],
    [/^(.+) je Stück$/, '$1 per piece'],
    [/^Farbe · (.+)$/, 'Colour · $1'],
    [/^Größe · (.+)$/, function (m, a) { return 'Size · ' + (a === 'bitte wählen' ? 'please choose' : a); }],
    [/^(.+) \((\d+) Logos?\)$/, function (m, a, n) { return a + ' (' + n + (n === '1' ? ' logo)' : ' logos)'); }],
    [/^Noch (\d+) Teile? bis zur Mindestmenge von (\d+) Stück – Farben und Größen frei kombinierbar\.$/, function (m, a, b) { return pcs(a).replace(/^(\d+)/, '$1 more') + ' to reach the minimum of ' + b + ' pieces – mix colours and sizes freely.'; }],
    [/^Noch (.+) bis zum Mindestbestellwert$/, '$1 more to reach the minimum order value'],
    [/^Danach versandkostenfrei und (\d+) % Staffelrabatt\.$/, 'Then free shipping and $1 % volume discount.'],
    [/^Danach versandkostenfrei$/, 'Then free shipping'],
    [/^Staffelrabatt ab (.+) Bestellwert\.$/, 'volume discount from $1 order value.'],
    [/^Noch (.+) bis (\d+) % Rabatt$/, '$1 more to $2 % discount'],
    [/^(\d+) % Rabatt$/, '$1 % discount'],
    [/^(\d+) % aktiv$/, '$1 % active'],
    [/^(\d+) % Rabatt aktiv$/, '$1 % discount active'],
    [/^Staffelrabatt (\d+) %$/, 'Volume discount $1 %'],
    [/^frei ab (.+)$/, 'free from $1'],
    [/^noch (.+) bis Mindestwert$/, '$1 more to minimum'],
    [/^Versand kostenfrei$/, 'free shipping'],
    [/^Ohne Rabatt ab (.+)$/, 'Without discount from $1'],
    [/^mit (\d+) % Staffelrabatt ab (.+) Bestellwert$/, 'with $1 % volume discount from $2 order value'],
    [/^entspricht (.+) je Stück$/, 'equals $1 per piece'],
    [/^Bitte mindestens (\d+) Teile eintragen – Farben und Größen dürfen gemischt werden\.$/, 'Please enter at least $1 pieces – colours and sizes can be mixed.'],
    [/^Bitte lade die Datei für Logo (\d+) hoch oder hake „Logo-Dateien schicke ich nach der Bestellung“ an\.$/, 'Please upload the file for logo $1 or tick “I’ll send the logo files by email after ordering”.'],
    [/^Im Warenkorb: (\d+) Stk\. ·$/, 'In your cart: $1 pcs ·'],
    [/^Vorschau (Vorne|Hinten) groß zeigen$/, function (m, s) { return 'Enlarge ' + (s === 'Vorne' ? 'front' : 'back') + ' preview'; }],
    [/^Logo (\d+), (.+), ([\d,.]+) cm breit\. Mit Maus, Finger oder Pfeiltasten verschieben\.$/, function (m, n, p, w) { return 'Logo ' + n + ', ' + pos(p) + ', ' + w + ' cm wide. Move with mouse, finger or arrow keys.'; }],
    [/^Für deine Musterbox · bis zu (\d+) Teile$/, 'For your sample box · up to $1 pieces'],
    [/^(\d+) Teile?$/, function (m, n) { return pcs(n); }],
    [/^Deine Musterbox ist voll \((\d+) Teile\)\.$/, 'Your sample box is full ($1 pieces).'],
    [/^Dein Browser speichert die Musterbox nicht\. Bitte schreib uns an (.+)\.$/, 'Your browser doesn’t save the sample box. Please email us at $1.'],
    [/^Farbe: (.+)$/, 'Colour: $1'],
    [/^Größe: (.+)$/, 'Size: $1'],
    [/^Die Menge für das Produkt (.+) sollte größer oder gleich (\d+) sein\.$/, 'The quantity for the product $1 should be at least $2.'],
    [/^© (\d{4}) (.+)\. Alle Rechte vorbehalten\.$/, '© $1 $2. All rights reserved.'],
    // SP-MUETZE (12.10.2026) / Inhaber 17.10.2026: Druckfläche bleibt im deutschen Zahlenformat (Komma, z. B. „max. 11 × 2,5 cm“), auch unter /en/
    [/^max\. ([\d.,]+) × ([\d.,]+) cm$/, function (m, a, b) { return 'max. ' + a.replace('.', ',') + ' × ' + b.replace('.', ',') + ' cm'; }]
  ];

  // Sätze innerhalb längerer Texte (Hinweiszeile der Logo-Vorschau)
  var S = [
    [/Gestrichelt: größte Druckfläche für (.+?) \(([\d.,]+) × ([\d.,]+) cm\)\./g, function (m, p, a, b) { return 'Dashed: largest print area for ' + pos(p) + ' (' + a + ' × ' + b + ' cm).'; }],
    [/Gestrichelt: Druckfläche am Kragen \(([\d.,]+) × ([\d.,]+) cm\)\. Noch kein Logo am Kragen – wähle bei einem Logo die Position „Kragen links“ oder „Kragen rechts“\./g, 'Dashed: print area on the collar ($1 × $2 cm). No logo on the collar yet – choose “Left collar” or “Right collar” as the position of a logo.'],
    [/Gestrichelt: Druckfläche am Ärmel \(([\d.,]+) × ([\d.,]+) cm\)\. Noch kein Logo am Ärmel – wähle bei einem Logo die Position „Ärmel links“ oder „Ärmel rechts“\./g, 'Dashed: print area on the sleeve ($1 × $2 cm). No logo on the sleeve yet – choose “Left sleeve” or “Right sleeve” as the position of a logo.'],
    [/Logo ziehen zum Verschieben\./g, 'Drag the logo to move it.'],
    [/Hinten ist noch kein Logo platziert\./g, 'No logo placed on the back yet.'],
    [/Vorne ist noch kein Logo platziert\./g, 'No logo placed on the front yet.'],
    [/Logo (\d+) ist größer als die Druckfläche für (.+?) \(max\. ([\d.,]+) × ([\d.,]+) cm\)\./g, function (m, n, p, a, b) { return 'Logo ' + n + ' is larger than the print area for ' + pos(p) + ' (max. ' + a + ' × ' + b + ' cm).'; }],
    [/Vorschau ungefähr – die genaue Platzierung zeigen wir dir mit der Druckfreigabe\./g, 'Approximate preview – we’ll show you the exact placement with the print approval.'],
    [/Für diese Farbe gibt es kein Foto der Rückseite – die Vorschau nutzt das Vorderfoto\./g, 'There is no back photo for this colour – the preview uses the front photo.']
  ];

  // Materialangaben (Metafelder) – nur in der Datenzeile und der Materialtabelle
  var MAT = [[/Bio-Baumwolle/g, 'organic cotton'], [/recyceltes Polyester/gi, 'recycled polyester'], [/recyceltem Polyester/gi, 'recycled polyester'], [/Baumwolle/g, 'cotton'], [/Elasthan/g, 'elastane'], [/Viskose/g, 'viscose'], [/Wolle/g, 'wool'], [/ringgesponnene?/g, 'ring-spun'], [/gekämmte?/g, 'combed'], [/ und /g, ' and ']];

  function core(t) {
    if (Object.prototype.hasOwnProperty.call(X, t)) return X[t];
    if (Object.prototype.hasOwnProperty.call(POS, t)) return POS[t];
    // Texte mit „ · “ werden in Teilen übersetzt – außer eine Regel kennt den ganzen Text (enthält selbst „·“)
    var dot = t.indexOf(' · ') >= 0;
    for (var i = 0; i < R.length; i++) {
      if (dot && R[i][0].source.indexOf('·') < 0) continue;
      if (R[i][0].test(t)) return t.replace(R[i][0], R[i][1]);
    }
    return null;
  }
  function tr(s, mat) {
    var m = /^(\s*)([\s\S]*?)(\s*)$/.exec(s), t = m[2];
    if (!t || !/[A-Za-zÄÖÜäöüß]/.test(t)) return s;
    var r = core(t);
    if (r === null && t.indexOf(' · ') > 0) {
      var ch = false, seg = t.split(' · ').map(function (x) { var y = core(x); if (y !== null) { ch = true; return y; } return x; });
      if (ch) r = seg.join(' · ');
    }
    if (r === null) {
      var u = t;
      S.forEach(function (p) { u = u.replace(p[0], p[1]); });
      if (mat) MAT.forEach(function (p) { u = u.replace(p[0], p[1]); });
      if (u !== t) r = u;
    }
    return r === null ? s : m[1] + r + m[3];
  }

  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, TEMPLATE: 1, TITLE: 1 };
  var ATTRS = ['title', 'aria-label', 'placeholder'];
  var SHADOW = /^\s*(bis zu \d+ Logos|1 Logo)\s*$/;
  var FIN = /Digitaldruck|Stick/;

  function txt(n) {
    var p = n.parentNode;
    if (!p || p.nodeType !== 1 || SKIP[p.nodeName]) return;
    var v = n.nodeValue;
    if (!v || !/[A-Za-zÄÖÜäöüß]/.test(v)) return;
    if (p.closest('[contenteditable],.notranslate,[translate="no"]')) return;
    // sp-pdp-de.js erkennt die Technik am deutschen Wort und setzt Symbol/Etikett – erst danach übersetzen
    var seg = p.closest('.spn-seg__btn');
    if (seg && !seg.querySelector('.spn-fin-ic') && FIN.test(v)) return;
    if (p.parentNode && p.parentNode.classList && p.parentNode.classList.contains('spn-logo__title') && v.indexOf(' · ') >= 0 && FIN.test(v)) return;
    // sp-pdp-neu.js liest „bis zu 2 Logos“ wieder aus – Text bleibt deutsch, angezeigt wird Englisch
    if (p.classList.contains('spn-step__meta') && SHADOW.test(v)) {
      var en = tr(v).trim();
      if (p.getAttribute('data-sp-en') !== en) {
        if (!p.style.getPropertyValue('--sp-en-c')) p.style.setProperty('--sp-en-c', getComputedStyle(p).color);
        p.setAttribute('data-sp-en', en);
        p.classList.add('sp-en-shadow');
      }
      return;
    }
    var mat = !!p.closest('.spn-facts2,.sp-mat__v');
    var u = tr(v, mat);
    if (u !== v) n.nodeValue = u;
  }
  function attr(e, a) {
    var v = e.getAttribute(a);
    if (!v || !/[A-Za-zÄÖÜäöüß]/.test(v)) return;
    var u = tr(v);
    if (u !== v) e.setAttribute(a, u);
  }
  function el(e) {
    if (SKIP[e.nodeName]) return;
    for (var i = 0; i < ATTRS.length; i++) if (e.hasAttribute(ATTRS[i])) attr(e, ATTRS[i]);
  }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) return txt(root);
    if (root.nodeType !== 1 || SKIP[root.nodeName]) return;
    el(root);
    var w = document.createTreeWalker(root, 5, null), n; // SHOW_ELEMENT | SHOW_TEXT
    while ((n = w.nextNode())) {
      if (n.nodeType === 3) txt(n);
      else el(n);
    }
  }

  var css = document.createElement('style');
  css.textContent = '.sp-en-shadow{position:relative;color:transparent!important;white-space:nowrap}' +
    '.sp-en-shadow::after{content:attr(data-sp-en);position:absolute;left:0;right:0;top:0;color:var(--sp-en-c,#5E656B);text-align:inherit}';
  (document.head || document.documentElement).appendChild(css);

  walk(document.body || document.documentElement);
  new MutationObserver(function (recs) {
    for (var i = 0; i < recs.length; i++) {
      var r = recs[i];
      if (r.type === 'characterData') txt(r.target);
      else if (r.type === 'attributes') { if (r.target.nodeType === 1) attr(r.target, r.attributeName); }
      else {
        for (var j = 0; j < r.addedNodes.length; j++) walk(r.addedNodes[j]);
        var t = r.target;
        if (t && t.nodeType === 1) {
          var box = t.closest('.spn-seg__btn,.spn-logo__title');
          if (box) walk(box);
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  document.addEventListener('DOMContentLoaded', function () { walk(document.body); });
  window.spI18nEn = { tr: tr, walk: walk };
})();
